import { Box, Typography } from "@mui/material";
import { EventStatusPill } from "./EventStatusPill";
import { eventDate } from "../../events/eventDate";
import { RankingsSeries } from "./RankingsSeries";
import { EventLocation } from "./EventLocation";
import { trackingCategory } from "../../../utils/tracking";
import { LinkSponsorTags } from "../sponsors/LinkSponsorTag";

export const EventHeaderDetails = ({ event, classes }) => {
    const sponsoredContents = event.sponsoredContents;

    return (
        <>
            <Box display="flex" alignItems="center">
                <Typography className={classes.eventDate} variant="label2">
                    {eventDate({ date: event.date, window: event.daysWindow })}
                </Typography>
                <EventStatusPill status={event.status} />
            </Box>
            <Typography variant="h3" component="h1" className={classes.name}>
                {event.name}
            </Typography>
            <LinkSponsorTags
                sponsoredContents={sponsoredContents}
                key={event.id}
                clickTrackingCategory={
                    trackingCategory.sponsorIntegrationAtEvent
                }
                className={classes.sponsoredContent}
            />
            <RankingsSeries />
            <EventLocation location={event.location} />
        </>
    );
};
